import { get, post, put, del, getPage } from '@/utils/request'
import type { Project } from '@/types'

/** 获取项目列表（分页） */
export function getProjects(params?: { page?: number; page_size?: number; keyword?: string }) {
  return getPage<Project>('/projects', params)
}

/** 获取所有项目（不分页，用于下拉选择） */
export async function getAllProjects(): Promise<Project[]> {
  const res = await getProjects({ page: 1, page_size: 200 })
  return res.data
}

/** 获取项目详情 */
export function getProject(id: number) {
  return get<Project>(`/projects/${id}`)
}

/** 创建项目 */
export function createProject(data: { name: string; key: string; description?: string; color?: string; owner_id: number; members?: number[] }) {
  return post<Project>('/projects', data)
}

/** 更新项目 */
export function updateProject(id: number, data: Partial<Project>) {
  return put<Project>(`/projects/${id}`, data)
}

/** 删除项目 */
export function deleteProject(id: number) {
  return del(`/projects/${id}`)
}

/** 项目数据资产盘点（删除前校验用） */
export interface ProjectAssetSummary {
  has_data: boolean
  items: { label: string; count: number }[]
}

/** 盘点项目下各类数据资产 */
export function getProjectAssets(id: number) {
  return get<ProjectAssetSummary>(`/projects/${id}/assets`)
}
